import { h } from "preact";
import { RoutableProps } from "preact-router";

export function NotFound(props: RoutableProps) {
    return <div style="margin-top: 100px; text-align: center;">
        <h1 style="font-size: 40px">Podany adres nie istnieje</h1>
        <button onClick={() => history.back()}>Wróć do poprzedniej strony</button>
    </div>;
}
